export const editMyDetailsRoutes = {
  editMyDetailsStatePath: 'edit-my-details',
  editMyDetailsTitle: 'Edit my details | Learn My Way'
};